import type { IconProps } from './../../models/icon';

export function RemoveIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          d="M12 23.1429C18.1542 23.1429 23.1429 18.1542 23.1429 12C23.1429 5.84601 18.1542 0.857178 12 0.857178C5.84601 0.857178 0.857178 5.84601 0.857178 12C0.857178 18.1542 5.84601 23.1429 12 23.1429Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12 23.1429C18.1541 23.1429 23.1429 18.1541 23.1429 12C23.1429 5.84601 18.1541 0.857178 12 0.857178C5.84601 0.857178 0.857178 5.84601 0.857178 12C0.857178 18.1541 5.84601 23.1429 12 23.1429Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M6.85718 12H17.1429"
        />
      </g>
    </svg>
  );
}
